const vars = {
  VITE_GXL_ENVIRONMENT: import.meta.env.VITE_GXL_ENVIRONMENT,
  VITE_SIMULATE_PROD: import.meta.env.VITE_SIMULATE_PROD,
  VITE_BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
} as const;

if (import.meta.env.VITE_GXL_ENVIRONMENT !== "prod") {
  Object.entries(vars).forEach(([key, value]) => {
    if (value === undefined) {
      console.warn(`[config] Environment variable ${key} is not set`);
    }
  });
}

export const GXL_ENVIRONMENT =
  vars.VITE_SIMULATE_PROD === "true" ? "prod" : vars.VITE_GXL_ENVIRONMENT;
export const IS_PRODUCTION = GXL_ENVIRONMENT === "prod";
export const IS_STAGING = GXL_ENVIRONMENT === "staging";
export const IS_DEV = GXL_ENVIRONMENT === "dev";

/** Marketing site + blog for this environment (staging links stay on staging). */
export const WEBSITE_URL = IS_PRODUCTION ? "https://gxl.ai" : "https://www.staging.gxl.ai";

export const BASE_API_URL = `${vars.VITE_BACKEND_URL || ""}/api`;

export const FIREBASE_API_KEY = vars.VITE_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = vars.VITE_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = vars.VITE_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = vars.VITE_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = vars.VITE_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = vars.VITE_FIREBASE_APP_ID;
